import React from 'react';
import {Flex, Modal} from "antd";
import CustomButton from "../../../../../../components/UI/CustomButton/CustomButton";
import './NonVerifyCompanyModal.scss'

interface NonVerifyCompanyModalProps {
  visible: boolean;
  onClose: () => void;
}

const NonVerifyCompanyModal = ({visible, onClose}: NonVerifyCompanyModalProps) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      closable={false}
      className="NonVerifyCompanyModal"
    >
      <Flex vertical justify={"center"} align={"center"} gap={'50px'} className="NonVerifyCompanyModal__content">
        <Flex vertical gap={'13px'} className="NonVerifyCompanyModal__header">
          <p className="NonVerifyCompanyModal__header__description">
            You need to be verified by the company to view the content
          </p>
        </Flex>
        <Flex gap={'30px'} vertical className="NonVerifyCompanyModal__button">
          <CustomButton text={'Okay'} disable={false} onClick={() => onClose()}/>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default NonVerifyCompanyModal;